import { RouterProvider } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { TRPCProvider } from "./providers/trpc-provider";
import { PostHogProvider } from "./providers/posthog-provider";
import { router } from "./router";

function AppInner() {
  return (
    <PostHogProvider>
      <TRPCProvider>
        <RouterProvider router={router} />
      </TRPCProvider>
    </PostHogProvider>
  );
}

export function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="min-h-screen flex items-center justify-center bg-[var(--color-bg-primary)]">
          <div className="text-center max-w-md mx-auto p-8">
            <h1 className="text-2xl font-bold text-[var(--color-text-primary)] mb-4">
              Something went wrong
            </h1>
            <p className="text-[var(--color-text-secondary)] mb-6">
              {error instanceof Error
                ? error.message
                : "An unexpected error occurred"}
            </p>
            <button
              onClick={resetError}
              className="px-4 py-2 bg-[var(--color-primary-500)] text-white rounded-md hover:bg-[var(--color-primary-600)] transition-colors"
            >
              Try again
            </button>
          </div>
        </div>
      )}
    >
      <AppInner />
    </Sentry.ErrorBoundary>
  );
}
